import React from 'react';
import clsx from 'clsx';
import { convertToCSV, downloadCSV, CSVColumn } from '../../utils/csvExport';
import styles from '../../styles/common/CSVDownloadButton.module.scss';

interface CSVDownloadButtonProps {
  data: any[];
  columns: CSVColumn[];
  filename: string;
  disabled?: boolean;
  className?: string;
}

function CSVDownloadButton({ 
  data, 
  columns, 
  filename, 
  disabled = false, 
  className 
}: CSVDownloadButtonProps) {
  const handleDownload = () => {
    if (!data || data.length === 0) {
      console.warn('No data available for CSV export');
      return;
    }

    try {
      const csvContent = convertToCSV(data, columns);
      const timestamp = new Date().toISOString().slice(0, 19).replace(/:/g, '-');
      const finalFilename = `${filename}_${timestamp}.csv`;
      downloadCSV(csvContent, finalFilename);
    } catch (error) {
      console.error('Error exporting CSV:', error);
    }
  };

  return (
    <button
      onClick={handleDownload}
      disabled={disabled || !data || data.length === 0}
      className={clsx(styles.csvDownloadButton, className)}
      title="Download CSV"
    >
      <svg 
        width="10" 
        height="10" 
        viewBox="0 0 24 24" 
        fill="none"
        style={{
          width: '10px',
          height: '10px',
          minWidth: '10px',
          minHeight: '10px',
          maxWidth: '10px',
          maxHeight: '10px',
          flexShrink: 0
        }}
      >
        <path 
          d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M7 10l5 5 5-5M12 15V3" 
          stroke="currentColor" 
          strokeWidth="1.5" 
          strokeLinecap="round" 
          strokeLinejoin="round"
        />
      </svg>
      Download CSV
    </button>
  );
}

export default CSVDownloadButton;
